export default "__VITE_ASSET__D$Nz7BMs__"